const shareBtnSelector = '.share-btn';
const shareFormSelector = '.share-form';
const hostAttr = 'data-api-host';
const siteLoader = document.querySelector('.site-loader-modal');
const shareUrl = '/share';
const navSlug = document.querySelector('meta[name="cv-nav-slug"]');
const oemSlug = document.querySelector('meta[name="cv-oem-slug"]');


function sharePageUrl(){
    const topicParam = encodeURIComponent(window.location.href);
    const titleParam = encodeURIComponent(document.title);
    return `${shareUrl}?topic=${topicParam}&title=${titleParam}&nav=${navSlug.getAttribute('content')}&oem=${oemSlug.getAttribute('content')}`;
}


function initShareForm(){
    document.querySelectorAll(shareFormSelector).forEach( form => {
        function submitHandler(e) {
            e.preventDefault();
            siteLoader.classList.add('show');
            let shareData = {
                'source': window.location.hostname,
                'url': form.querySelector('#topic_url').value,
                'title': form.querySelector('#topic_title').value,
                'recipient_name': form.querySelector('#recipient_name').value,
                'recipient_email': form.querySelector('#recipient_email').value,
                'sender_name': form.querySelector('#sender_name').value,
                'sender_email': form.querySelector('#sender_email').value,
                'message': form.querySelector('#message').value,
            };
            console.log(shareData);
            let host = e.target.getAttribute(hostAttr);
            if (!host){
                host = '';
            }
            console.log(`using ${host}`);
            fetch(host + shareUrl, {
                    'method': 'POST',
                    'headers': {
                        'content-type': 'application/json',
                        'accept': 'text/html',
                    },
                    'cache': 'no-cache',
                    'body': JSON.stringify(shareData)
                })
                .then(function (response) {
                    return response.text();
                })
                .then(function (html) {
                    siteLoader.classList.remove('show');
                    form.innerHTML = html;
                })
                .catch(err => {
                    siteLoader.classList.remove('show');
                    form.innerHTML = '<p>Something went wrong. Reload the page and try again.</p>';
                });
        }
        form.addEventListener('submit', submitHandler);
    });
}

function shareBtnHandler(e){
    const shareBtn = e.target.closest(shareBtnSelector);
    if (shareBtn){
        shareBtn.setAttribute('href', sharePageUrl());
    }
}

export default {shareBtnHandler, initShareForm};